module.exports = __webpack_public_path__ + "assets/icon-feeling-negative-component.6bba1165.svg";